"use strict";

let _ = require("lodash");
let $ = require("jquery");
let renderUploader = require("./uploader.ejs");
let renderProgress = require("./progress.ejs");
let eventize = require("../eventize");

/**
 * options:
 *   container (required)
 *   url (required)
 *
 *
 * @param options
 * @constructor
 */
let Uploader = function (options) {
    let me = this;

    let form = $(renderUploader({
        accept: options.accept
    }));

    me.$button = $(".upload-file", form);

    me.$button.click(function() {
        $(".file-input", form).val("").click();
    });

    $('.file-input', form).change(function() {
        let file = this.files[0];
		let ext = file.name.split('.').pop();
        let test = new RegExp("(^|,\.)" + ext + "(,|$)");

        if (options.accept && !test.exec(options.accept)) {
            alert("Недопустимый тип файла");
            return;
        }

        let progress = $(renderProgress()).appendTo($(".file-progresses", form));
        let fileName = $(this).val();

        let fd = new FormData();
        fd.append('file', this.files[0]);
        fd.append('maxs', options.maxs);

        let jqXhr = $.ajax({
            url: options.url,
            type: 'POST',
            dataType: 'json',
            data: fd,
            processData: false,
            contentType: false,

            xhr: function() {
                let xhr = new XMLHttpRequest();

                xhr.upload.onprogress = function(e) {
                    $('.uploader-widget-bar-fill', progress).css('width', (e.loaded / e.total * 100) + '%');
                };

                return xhr;
            },

            success: function (responce) {
            	if (responce.success)
                	me.trigger("success", responce.data);
            	else
            		alert(responce.message)
            },

            error: function (jqXHR, status, error) {
                if (status != "abort") {

                    // $('.file-errors', form).append(
                    //     disappearingAlert('Файл ' + fileName + ' не загружен. ' + status + ' ' + error, 0)
                    // );

                    me.trigger("fail", status, error);
                }
            },

            complete: function () {
                progress.remove();
            }
        });

        $('.uploader-widget-cancel-upload', progress).click(function() {
            jqXhr.abort();
            progress.remove();
        });
    });

    form.appendTo(options.container);
    this.element = form[0];
};

eventize(Uploader.prototype);

Uploader.prototype.enable = function () {
    this.$button.prop("disabled", false);
};

Uploader.prototype.disable = function () {
    this.$button.prop("disabled", true);
};

module.exports = Uploader;
